import register from '../util/init'
import AnnualTargetChart from './charts/annual_target'
import AnnualFlowChart from './charts/annual_flow'
import KiwisaverChart from './charts/kiwisaver'
import FumDistributionBarSmallChart from './charts/fum_distribution_bar_small'
import FumDistributionDonutChart from './charts/fum_distribution'
import PortfolioOverview from './charts/portfolio_overview'
import GrowthLossChart from './charts/growth_loss'
import ActualExpectedChart from './charts/actual_expected'
import ClientsChart from './charts/clients'
import Chart from 'chart.js'

// Search dashboard for different charts and initialise and update with
// data from fetch
export function dashboard(
  container,
  id = '',
  portfolioid = ''
) {
  Chart.defaults.global.defaultFontFamily = 'heldane-text-regular'

  let annualTargetChart
  let annualFlowChart
  let fumDistributionBarSmallChart
  let fumDistributionDonutChart
  let portfolioOverView
  let growthLossChart
  let actualExpectedChart
  let kiwisaverChart
  let clientsChart

  if (document.getElementById('annual-target-chart')) {
    annualTargetChart = new AnnualTargetChart()
  }
  if (document.getElementById('annual-flow-chart')) {
    annualFlowChart = new AnnualFlowChart()
  }
  if (document.getElementById('clients-chart')) {
    clientsChart = new ClientsChart()
  }
  if (document.getElementById('fum-distribution-bar-small')) {
    fumDistributionBarSmallChart = new FumDistributionBarSmallChart()
  }
  if (document.getElementById('fum-distribution-donut')) {
    fumDistributionDonutChart = new FumDistributionDonutChart()
  }
  if (document.getElementById('portfolio-overview')) {
    portfolioOverView = new PortfolioOverview()
  }
  if (document.getElementById('growth-loss-chart')) {
    growthLossChart = new GrowthLossChart()
  }
  if (document.getElementById('actual-expected-chart')) {
    actualExpectedChart = new ActualExpectedChart()
  }
  if (document.getElementById('kiwisaver-chart')) {
    kiwisaverChart = new KiwisaverChart()
  }

  const bodyClass = document.querySelector('body').classList
  let location = ''
  let userId = window.location.pathname.split('/')[2] || ''
  if (bodyClass.contains('index')) {
    if (bodyClass.contains('adviser-view')) {

      location = window.location.pathname + '/data/' + id
      if (kiwisaverChart) {
        location =
          window.location.pathname + '/kiwisaverdata/' + id
      }
    } else {
      location = '/portfolio/data/' + id
      if (kiwisaverChart) {
        location = 'portfolio/kiwisaverdata/' + userId
      }
    }
  }
  if (bodyClass.contains('firms')) {
    location = '/portfolio/firmdata'
  }
  if (
    bodyClass.contains('portfolio-detail') ||
    bodyClass.contains('portfolios')
  ) {
    let accountNumber = window.location.href.split('/')
    accountNumber = accountNumber.pop() || accountNumber.pop()
    if (accountNumber === 'portfolio') {
      accountNumber = portfolioid
    }
    location = '/portfolio/portfoliodetaildata/' + accountNumber
  }

  window
    .fetch(location, { credentials: 'include' })
    .then(response => {
      return response.json()
    })
    .then(JsonResponse => {
      if (annualTargetChart) {
        annualTargetChart.updateAnnualTargetData(
          JsonResponse.annual_target.data
        )
        clientsChart.updateClientsData(JsonResponse.annual_target.data)
      }
      if (annualFlowChart) {
        annualFlowChart.updateAnnualFlowData(
          JsonResponse.annual_flow.data
        )
      }
      if (fumDistributionBarSmallChart) {
        fumDistributionDonutChart.updateFumDistributionData(
          JsonResponse.service_levels.data
        )
        fumDistributionDonutChart.tooltipListen()
      }
      if (fumDistributionDonutChart) {
        fumDistributionBarSmallChart.updateFumDistributionBarSmallData(
          JsonResponse.fum_distribution_bar_small.data
        )
      }
      if (portfolioOverView) {
        portfolioOverView.updatePortfolioOverviewData(
          JsonResponse.portfolio_overview.data
        )
      }
      if (growthLossChart) {
        growthLossChart.updateGrowthLossData(JsonResponse.portfolio_data.data)
      }
      if (actualExpectedChart) {
        actualExpectedChart.updateActualExpectedData(
          JsonResponse.portfolio_data.data
        )
      }
      if (kiwisaverChart) {
        kiwisaverChart.updateKiwisaverData(JsonResponse.data)
      }
    })
}

register('.dashboard', dashboard)



// WEBPACK FOOTER //
// ./assets/j/src/dashboard.js